export default [
  {
    _name: 'CSidebarNav',
    _children: [
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Dashboard',
      //   route: '/Dashboard',
      //   icon: 'cil-speedometer',
      //   _attrs: { class: 'c-active' },
      // },
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/Dashboard',
        icon: 'cil-speedometer',
        _attrs: { class: 'c-active c-sidebar-nav-item' },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Learning',
        route: '/Learning',
        icon: 'cil-user',
        to: '/Learning',
      },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Class',
      //   route: '/LearningClass',
      //   icon: 'cil-wallet',
      //   to: '/LearningClass',
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Payment',
      //   route: '/Payment',
      //   icon: 'cil-dollar',
      //   to: '/Payment',
      // },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Template Main Website',
        route: '/Template/list',
        icon: 'cil-cog',
        items: [
          {
            name: 'List',
            icon: 'cil-book',
            to: '/template/list'
          },
        
          
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Analysis',
        route: '/Analysis/SalesReport',
        icon: 'cil-cog',
        items: [
          {
            name: 'Sales Report',
            icon: 'cil-dollar',
            to: '/analysis/salesReport'
          },
          {
            name: 'Products Report',
            icon: 'cil-dollar',
            to: '/analysis/productReport'
          },
          {
            name: 'Affiliate Staff',
            icon: 'cil-dollar',
            to: '/analysis/affiliateStaff'
          },
          {
            name: 'External Staff',
            icon: 'cil-dollar',
            to: '/analysis/affiliateExternal'
          },
          {
            name: 'List Affiliate',
            icon: 'cil-dollar',
            to: '/analysis/listAffiliate'
          },
          {
            name: 'Purchase Summary',
            icon: 'cil-dollar',
            to: '/analysis/purchaseSummary'
          },
          {
            name: 'List User',
            icon: 'cil-dollar',
            to: '/analysis/ListUser'
          },
        
          
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Manage Package',
        to: '/ManagePackage',
        icon: 'cil-speedometer',
        _attrs: { class: 'c-active c-sidebar-nav-item' },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Manage Coupon',
        to: '/CouponPage',
        icon: 'cil-speedometer',
        _attrs: { class: 'c-active c-sidebar-nav-item' },
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Learning Setting',
        route: '/TuitionSubject',
        icon: 'cil-cog',
        items: [
          {
            name: 'Subject',
            icon: 'cil-book',
            to: '/TuitionSubject'
          },
          {
            name: 'Package',
            icon: 'cil-clone',
            to: '/TuitionPackage'
          },
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Learning People',
        route: '/TuitionStudent',
        icon: 'cil-user',
        items: [
          {
            name: 'Student',
            icon: 'cil-user',
            to: '/TuitionStudent'
          },
          {
            name: 'Student(New)',
            icon: 'cil-user',
            to: '/TuitionStudentNew'
          },
          {
            name: 'Teacher',
            icon: 'cil-user-female',
            to: '/TuitionTeacher'
          },
          { 
            name: 'Register Student',
            icon: 'cil-user',
            to: '/RegisterStudent'
          },
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Attendance',
        route: '/TuitionAttendanceStudent',
        icon: 'cil-contact',
        items: [
          {
            name: 'Student Attendance',
            icon: 'cil-calendar-check',
            to: '/TuitionAttendanceStudent'
          },
          {
            name: 'Teacher Attendance',
            icon: 'cil-calendar-check',
            to: '/TuitionAttendanceTeacher'
          },
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Payment',
        route: '/TuitionPaymentStudent',
        icon: 'cil-dollar',
        items: [
          {
            name: 'Student Payment',
            icon: 'cil-cash',
            to: '/TuitionPaymentStudent'
          },
          {
            name: 'Teacher Payment',
            icon: 'cil-cash',
            to: '/TuitionPaymentTeacher'
          },
        ]
      },
       // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Schedule',
      //   to: 'TuitionSchedule',
      //   icon: 'cil-calendar',
      // },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Schedule',
        route: '/TuitionSchedule',
        icon: 'cil-calendar',
        items: [
          {
            name: 'Schedule',
            icon: 'cil-calendar-check',
            to: '/ScheduleList'
          },
          {
            name: 'Previous Schedule',
            icon: 'cil-calendar-check',
            to: '/TuitionSchedule'
          },
        ]
      },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Broadcast',
      //   to: 'TuitionBroadcast',
      //   icon: 'cil-bell',
      // },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Notification',
        route: '/TuitionBroadcast',
        icon: 'cil-bell',
        items: [
          {
            name: 'Broadcast',
            icon: 'cil-bell',
            to: '/TuitionBroadcast'
          },
          {
            name: 'Mass',
            icon: 'cil-bell',
            to: '/TuitionMassNotification'
          },
         
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'EPay',
        route: '/Epay',
        icon: 'cil-contact',
        items: [
          {
            name: 'EPay Transaction',
            icon: 'cil-calendar-check',
            to: '/EPayTransaction'
          },
          {
            name: 'EPay Total',
            icon: 'cil-calendar-check',
            to: '/EPayTotal'
          },
          {
            name: 'EPay Track',
            icon: 'cil-calendar-check',
            to: '/EPayTrack'
          },
          {
            name: 'EPay UnPaid',
            icon: 'cil-calendar-check',
            to: '/UnPaidTransaction'
          },
        ]
      },
    
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Purchase Summary',
      //   to: '/PurchaseSummary',
      //   icon: 'cil-speedometer',
      //   _attrs: { class: 'c-active c-sidebar-nav-item' },
      // },
      {
        _name: 'CSidebarNavItem',
        name: 'Billing',
        to: 'Billing',
        icon: 'cil-calculator',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Counter Visitor',
        to: 'CounterVisitor',
        icon: 'cil-calculator',
      },
      // {
      //   _name: 'CSidebarNavDropdown',
      //   name: 'Learning Setting',
      //   route: '/TuitionSubject',
      //   icon: 'cil-cog',
      //   items: [
      //     {
      //       name: 'Subject',
      //       icon: 'cil-book',
      //       to: '/TuitionSubject'
      //     },
      //     {
      //       name: 'Package',
      //       icon: 'cil-clone',
      //       to: '/TuitionPackage'
      //     },
      //   ]
      // },
      // {
      //   _name: 'CSidebarNavDropdown',
      //   name: 'Learning People',
      //   route: '/TuitionStudent',
      //   icon: 'cil-user',
      //   items: [
      //     {
      //       name: 'Student',
      //       icon: 'cil-user',
      //       to: '/TuitionStudent'
      //     },
      //     {
      //       name: 'Teacher',
      //       icon: 'cil-user-female',
      //       to: '/TuitionTeacher'
      //     },
      //     {
      //       name: 'Register Student',
      //       icon: 'cil-user',
      //       to: '/RegisterStudent'
      //     },
      //   ]
      // },
      // {
      //   _name: 'CSidebarNavDropdown',
      //   name: 'Attendance',
      //   route: '/TuitionAttendanceStudent',
      //   icon: 'cil-contact',
      //   items: [
      //     {
      //       name: 'Student Attendance',
      //       icon: 'cil-calendar-check',
      //       to: '/TuitionAttendanceStudent'
      //     },
      //     {
      //       name: 'Teacher Attendance',
      //       icon: 'cil-calendar-check',
      //       to: '/TuitionAttendanceTeacher'
      //     },
      //   ]
      // },
      // {
      //   _name: 'CSidebarNavDropdown',
      //   name: 'Payment',
      //   route: '/TuitionPaymentStudent',
      //   icon: 'cil-dollar',
      //   items: [
      //     {
      //       name: 'Student Payment',
      //       icon: 'cil-cash',
      //       to: '/TuitionPaymentStudent'
      //     },
      //     {
      //       name: 'Teacher Payment',
      //       icon: 'cil-cash',
      //       to: '/TuitionPaymentTeacher'
      //     },
      //   ]
      // },
      // {
      //   _name: 'CSidebarNavDropdown',
      //   name: 'Register',
      //   route: '/TuitionPaymentStudent',
      //   icon: 'cil-dollar',
      //   items: [
      //     {
      //       name: 'Register Fee',
      //       icon: 'cil-cash',
      //       to: '/TuitionRegistrationFee'
      //     },
      //   ]
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Schedule',
      //   to: 'TuitionSchedule',
      //   icon: 'cil-calendar',
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Broadcast',
      //   to: 'TuitionBroadcast',
      //   icon: 'cil-bell',
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Mass Notification',
      //   to: 'TuitionMassNotification',
      //   icon: 'cil-bell',
      // },

      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Notification',
      //   to: 'Notification',
      //   icon: 'cil-bell',
      // },
      
      // {
      //   _name: 'CSidebarNavTitle',
      //   _children: ['ACCOUNT PAGES']
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Profile',
      //   to: 'Profile',
      //   icon: 'cil-user',
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Sign Out',
      //   to: '',
      //   icon: 'cil-lock-locked',
      //   _attrs: { onclick: 'SignOut()',
      //   methods: {
      //     SignOut: function () {
      //       return this.$API
      //         .get(this.$SignOut, {
      //           withCredentials: true,
      //         })
      //         .then((response) => {
      //           if (response.status == 200) {
      //             this.$router.push("/Login");
      //           }
      //         });
      //     }
      //   }
      // }
      //},
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Sign Up',
      //   to: '',
      //   icon: 'cil-user-plus',
      //   _attrs: { class: 'disabledclass' },
      // },
     
    
     
     
    ],
   
  }
]




 